// Remove JSS stylesheets coming from server-side
export default function removeServerSideStylesheet() {
  const styles = document.getElementById('server-side-jss');

  styles.parentNode.removeChild(styles);
}
